import React, { useState } from 'react';
import { Card, Form, Row, Col, ButtonGroup, InputGroup } from 'react-bootstrap';
import { Formik } from 'formik';
import * as yup from 'yup';
import { useHistory } from 'react-router-dom';
import { useMutation, useQuery } from 'react-query';
import { toast } from 'react-toastify';
import { LOPDAOTAOTHUCHANH_API, DOITUONG_API } from '@app/utils/apiUrl';
import { Post, Get } from '@app/utils/httpProvider';
import { 
    messageError, 
    messageToast, 
    status200,
    trangThaiDotTuyenSinhValue,
    objectTrangThaiDotTuyenSinh,
    loaiTuyenSinhValue,
    objectLoaiTuyenSinh,
    objectDoiTuong,
    doiTuongValue,
    styleSelectDefault,
    styleSelectError
} from '../../../../../utils/define';
import { URI_INTERNAL } from '../../../../../utils/pathLocations';
import { Button } from '@components';
import HorizontalFieldsRow from '@app/components/common/HorizontalFieldsRow';
import Select from 'react-select';
import Editor from '../../../../../components/editor/Editor';
import DoiTuongMienGiamFields, { stringifyDoiTuongMienGiam } from '../dotTuyenSinh/DoiTuongMienGiamFields';

const schema = yup.object().shape({
    tenKhoaHoc: yup.string().required(messageError.emptyMessage).max(255, 'Tên khóa học không được vượt quá 255 ký tự'),
    loaiTuyenSinh: yup.string().required(messageError.emptyMessage),
    noiDungKhoaHoc: yup.string().nullable(),
    ngayKhaiGiang: yup.string().required(messageError.emptyMessage),
    ngayBatDauNhanHoSo: yup.date().nullable(),
    ngayKetThucNhanHoSo: yup.date().nullable(),
    doiTuongEnum: yup.string().required(messageError.emptyMessage),
    chucDanhIds: yup.array().nullable(),
    thoiGianBacSi: yup.number().min(0, 'Thời gian không được nhỏ hơn 0').nullable(),
    hocPhiBacSi: yup.number().min(0, 'Học phí không được nhỏ hơn 0').nullable(),
    thoiGianYSi: yup.number().min(0, 'Thời gian không được nhỏ hơn 0').nullable(),
    hocPhiYSi: yup.number().min(0, 'Học phí không được nhỏ hơn 0').nullable(),
    thoiGianDieuDuong: yup.number().min(0, 'Thời gian không được nhỏ hơn 0').nullable(),
    hocPhiDieuDuong: yup.number().min(0, 'Học phí không được nhỏ hơn 0').nullable(),
    thoiGianKTV: yup.number().min(0, 'Thời gian không được nhỏ hơn 0').nullable(),
    hocPhiKTV: yup.number().min(0, 'Học phí không được nhỏ hơn 0').nullable(),
    trangThaiDotTuyenSinh: yup.string().required(messageError.emptyMessage),
    doiTuongMienGiams: yup.array().when('coDoiTuongMienGiam', {
        is: true,
        then: yup.array().of(yup.object().shape({ tenDoiTuong: yup.string().trim().required('Vui lòng nhập tên đối tượng').max(255, 'Tên đối tượng không được vượt quá 255 ký tự') })).min(1, 'Vui lòng thêm ít nhất một đối tượng')
    }),
});

const LopDaoTaoThucHanhAdd = () => {
    const history = useHistory();
    const [isLoading, setIsLoading] = useState(false);

    const { data: doiTuongData } = useQuery(
        ['doiTuongDataLopThucHanh'],
        () => Get(DOITUONG_API.GET_PAGING, null, { PageIndex: 1, PageSize: 1000 }),
        { keepPreviousData: true }
    );
    const listDoiTuong = doiTuongData?.data?.$values || doiTuongData?.data || [];

    const addFunc = useMutation((value) =>
        Post(LOPDAOTAOTHUCHANH_API.ADD_ITEM, null, value, false)
    );

    const handleCreate = async (values) => {
        const { coDoiTuongMienGiam, doiTuongMienGiams } = values;
        const model = {
            TenKhoaHoc: values.tenKhoaHoc,
            LoaiTuyenSinh: values.loaiTuyenSinh,
            NoiDungKhoaHoc: values.noiDungKhoaHoc || '',
            NgayKhaiGiang: values.ngayKhaiGiang,
            NgayBatDauNhanHoSo: values.ngayBatDauNhanHoSo || null,
            NgayKetThucNhanHoSo: values.ngayKetThucNhanHoSo || null,
            DoiTuongEnum: values.doiTuongEnum,
            ChucDanhIds: values.chucDanhIds && values.chucDanhIds.length > 0 ? values.chucDanhIds.join(',') : null,
            ThoiGianBacSi: values.thoiGianBacSi === '' ? null : values.thoiGianBacSi,
            HocPhiBacSi: values.hocPhiBacSi === '' ? null : values.hocPhiBacSi,
            ThoiGianYSi: values.thoiGianYSi === '' ? null : values.thoiGianYSi,
            HocPhiYSi: values.hocPhiYSi === '' ? null : values.hocPhiYSi,
            ThoiGianDieuDuong: values.thoiGianDieuDuong === '' ? null : values.thoiGianDieuDuong,
            HocPhiDieuDuong: values.hocPhiDieuDuong === '' ? null : values.hocPhiDieuDuong,
            ThoiGianKTV: values.thoiGianKTV === '' ? null : values.thoiGianKTV,
            HocPhiKTV: values.hocPhiKTV === '' ? null : values.hocPhiKTV,
            TrangThaiDotTuyenSinh: values.trangThaiDotTuyenSinh,
            DoiTuongMienGiam: coDoiTuongMienGiam ? stringifyDoiTuongMienGiam(doiTuongMienGiams) : '',
        };

        addFunc.mutate(model, {
            onSuccess: (res) => {
                if (res.status !== status200) {
                    toast.error(messageToast.messageToastCreateError);
                } else {
                    setIsLoading(true);
                    toast.success(messageToast.messageToastCreateSuccess);
                    history.push(URI_INTERNAL.LOPDAOTAOTHUCHANH_PATH);
                }
            },
            onError: (res) => {
                toast.error(
                    res.message || 'Đã có lỗi xảy ra, vui lòng thử lại !'
                );
            }
        });
    };

    return (
        <Card>
            <Card.Header as="h5">Thêm mới Lớp Đào tạo thực hành</Card.Header>
            <Card.Body>
                <Formik
                    validationSchema={schema}
                    onSubmit={(values) => handleCreate(values)}
                    initialValues={{
                        tenKhoaHoc: '',
                        loaiTuyenSinh: loaiTuyenSinhValue.tuyenSinhDTTH,
                        noiDungKhoaHoc: '',
                        ngayKhaiGiang: '',
                        ngayBatDauNhanHoSo: '',
                        ngayKetThucNhanHoSo: '',
                        doiTuongEnum: doiTuongValue.quanVaDan,
                        chucDanhIds: [],
                        thoiGianBacSi: '',
                        hocPhiBacSi: '',
                        thoiGianYSi: '',
                        hocPhiYSi: '',
                        thoiGianDieuDuong: '',
                        hocPhiDieuDuong: '',
                        thoiGianKTV: '',
                        hocPhiKTV: '',
                        trangThaiDotTuyenSinh: trangThaiDotTuyenSinhValue.sapMo,
                        coDoiTuongMienGiam: false,
                        doiTuongMienGiams: [],
                    }}
                >
                    {({ handleSubmit, handleChange, values, errors, setFieldValue }) => {
                        const selectedChucDanhs = listDoiTuong
                            .filter(x => values.chucDanhIds && values.chucDanhIds.includes(x.id))
                            .map(x => (x.tenDoiTuong || '').toLowerCase());

                        const isBacSi = selectedChucDanhs.some(x => x.includes('bác sĩ') || x.includes('bac si'));
                        const isYSi = selectedChucDanhs.some(x => x.includes('y sĩ') || x.includes('y si'));
                        const isDieuDuong = selectedChucDanhs.some(x => x.includes('điều dưỡng') || x.includes('dieu duong'));
                        const isKTV = selectedChucDanhs.some(x => x.includes('ktv') || x.includes('kỹ thuật viên') || x.includes('ky thuat vien'));

                        return (
                        <Form noValidate onSubmit={handleSubmit}>
                            <HorizontalFieldsRow
                                fields={[
                                    {
                                        label: 'Tên khóa học',
                                        name: 'tenKhoaHoc',
                                        component: (
                                            <>
                                                <Form.Control type="text" name="tenKhoaHoc" value={values.tenKhoaHoc} onChange={handleChange} />
                                                {errors.tenKhoaHoc && <div className="text-danger small mt-1">{errors.tenKhoaHoc}</div>}
                                            </>
                                        ),
                                        required: true
                                    },
                                    {
                                        label: 'Loại tuyển sinh',
                                        name: 'loaiTuyenSinh',
                                        component: (
                                            <Form.Control
                                                as="select"
                                                name="loaiTuyenSinh"
                                                value={values.loaiTuyenSinh}
                                                onChange={handleChange}
                                            >
                                                {objectLoaiTuyenSinh.map(opt => <option key={opt.value} value={opt.value}>{opt.label}</option>)}
                                            </Form.Control>
                                        ),
                                        error: errors.loaiTuyenSinh,
                                        required: true
                                    },
                                ]}
                            />
                            <Row>
                                <Col md={12}>
                                    <Form.Group className="mb-3">
                                        <Form.Label className="font-weight-bold">Nội dung khóa học</Form.Label>
                                        <Editor
                                            name="noiDungKhoaHoc"
                                            value={values.noiDungKhoaHoc}
                                            onChange={(val) => setFieldValue('noiDungKhoaHoc', val)}
                                        />
                                    </Form.Group>
                                </Col>
                            </Row>
                            <HorizontalFieldsRow
                                fields={[
                                    {
                                        label: 'Ngày khai giảng',
                                        name: 'ngayKhaiGiang',
                                        component: (
                                            <>
                                                <Form.Control type="date" name="ngayKhaiGiang" value={values.ngayKhaiGiang} onChange={handleChange} />
                                                {errors.ngayKhaiGiang && <div className="text-danger small mt-1">{errors.ngayKhaiGiang}</div>}
                                            </>
                                        ),
                                        required: true
                                    },
                                    {
                                        label: 'Trạng thái',
                                        name: 'trangThaiDotTuyenSinh',
                                        component: (
                                            <Form.Control
                                                as="select"
                                                name="trangThaiDotTuyenSinh"
                                                value={values.trangThaiDotTuyenSinh}
                                                onChange={handleChange}
                                            >
                                                {objectTrangThaiDotTuyenSinh.map(opt => <option key={opt.value} value={opt.value}>{opt.label}</option>)}
                                            </Form.Control>
                                        ),
                                        error: errors.trangThaiDotTuyenSinh
                                    }
                                ]}
                            />
                            <HorizontalFieldsRow
                                fields={[
                                    {
                                        label: 'Ngày nhận hồ sơ',
                                        name: 'ngayBatDauNhanHoSo',
                                        component: (
                                            <>
                                                <Form.Control type="date" name="ngayBatDauNhanHoSo" value={values.ngayBatDauNhanHoSo} onChange={handleChange} />
                                                {errors.ngayBatDauNhanHoSo && <div className="text-danger small mt-1">{errors.ngayBatDauNhanHoSo}</div>}
                                            </>
                                        )
                                    },
                                    {
                                        label: 'Ngày kết thúc nhận',
                                        name: 'ngayKetThucNhanHoSo',
                                        component: (
                                            <>
                                                <Form.Control type="date" name="ngayKetThucNhanHoSo" value={values.ngayKetThucNhanHoSo} onChange={handleChange} />
                                                {errors.ngayKetThucNhanHoSo && <div className="text-danger small mt-1">{errors.ngayKetThucNhanHoSo}</div>}
                                            </>
                                        )
                                    },
                                ]}
                            />
                            <HorizontalFieldsRow
                                fields={[
                                    {
                                        label: 'Đối tượng',
                                        name: 'doiTuongEnum',
                                        component: (
                                            <Form.Control
                                                as="select"
                                                name="doiTuongEnum"
                                                value={values.doiTuongEnum}
                                                onChange={handleChange}
                                            >
                                                {objectDoiTuong.map(opt => <option key={opt.value} value={opt.value}>{opt.label}</option>)}
                                            </Form.Control>
                                        ),
                                        error: errors.doiTuongEnum,
                                        required: true
                                    },
                                    {
                                        label: 'Chức danh',
                                        name: 'chucDanhIds',
                                        component: (
                                            <Select
                                                isMulti
                                                name="chucDanhIds"
                                                placeholder="-- Chọn Chức danh --"
                                                value={values.chucDanhIds ? values.chucDanhIds.map(v => {
                                                    const item = listDoiTuong.find(x => x.id === v);
                                                    return { label: item ? item.tenDoiTuong : '', value: v };
                                                }) : []}
                                                options={listDoiTuong.map(opt => ({ label: opt.tenDoiTuong, value: opt.id }))}
                                                onChange={(opts) => {
                                                    setFieldValue('chucDanhIds', opts ? opts.map(x => x.value) : []);
                                                }}
                                                styles={errors.chucDanhIds ? styleSelectError : styleSelectDefault}
                                            />
                                        ),
                                        error: errors.chucDanhIds
                                    },
                                ]}
                            />


                            {(isBacSi || isYSi || isDieuDuong || isKTV) && <h6 className="mt-4 mb-3">Học phí & Thời gian theo đối tượng</h6>}
                            {isBacSi && (
                            <HorizontalFieldsRow
                                fields={[
                                    {
                                        label: 'Thời gian đào tạo Bác sĩ',
                                        name: 'thoiGianBacSi',
                                        component: (
                                            <InputGroup>
                                                <Form.Control
                                                    type="number"
                                                    name="thoiGianBacSi"
                                                    value={values.thoiGianBacSi}
                                                    onChange={handleChange}
                                                />
                                                <InputGroup.Text>tháng</InputGroup.Text>
                                            </InputGroup>
                                        ),
                                        error: errors.thoiGianBacSi,
                                    },
                                    {
                                        label: 'Học phí Bác sĩ',
                                        name: 'hocPhiBacSi',
                                        component: (
                                            <>
                                                <Form.Control type="number" name="hocPhiBacSi" value={values.hocPhiBacSi} onChange={handleChange} />
                                                {errors.hocPhiBacSi && <div className="text-danger small mt-1">{errors.hocPhiBacSi}</div>}
                                            </>
                                        )
                                    },
                                ]}
                            />
                            )}
                            {isYSi && (
                            <HorizontalFieldsRow
                                fields={[
                                    {
                                        label: 'Thời gian đào tạo Y sĩ',
                                        name: 'thoiGianYSi',
                                        component: (
                                            <InputGroup>
                                                <Form.Control
                                                    type="number"
                                                    name="thoiGianYSi"
                                                    value={values.thoiGianYSi}
                                                    onChange={handleChange}
                                                />
                                                <InputGroup.Text>tháng</InputGroup.Text>
                                            </InputGroup>
                                        ),
                                        error: errors.thoiGianYSi,
                                    },
                                    {
                                        label: 'Học phí Y sĩ',
                                        name: 'hocPhiYSi',
                                        component: (
                                            <>
                                                <Form.Control type="number" name="hocPhiYSi" value={values.hocPhiYSi} onChange={handleChange} />
                                                {errors.hocPhiYSi && <div className="text-danger small mt-1">{errors.hocPhiYSi}</div>}
                                            </>
                                        )
                                    },
                                ]}
                            />
                            )}
                            {isDieuDuong && (
                            <HorizontalFieldsRow
                                fields={[
                                    {
                                        label: 'Thời gian đào tạo Điều dưỡng',
                                        name: 'thoiGianDieuDuong',
                                        component: (
                                            <InputGroup>
                                                <Form.Control
                                                    type="number"
                                                    name="thoiGianDieuDuong"
                                                    value={values.thoiGianDieuDuong}
                                                    onChange={handleChange}
                                                />
                                                <InputGroup.Text>tháng</InputGroup.Text>
                                            </InputGroup>
                                        ),
                                        error: errors.thoiGianDieuDuong,
                                    },
                                    {
                                        label: 'Học phí Điều dưỡng',
                                        name: 'hocPhiDieuDuong',
                                        component: (
                                            <>
                                                <Form.Control type="number" name="hocPhiDieuDuong" value={values.hocPhiDieuDuong} onChange={handleChange} />
                                                {errors.hocPhiDieuDuong && <div className="text-danger small mt-1">{errors.hocPhiDieuDuong}</div>}
                                            </>
                                        )
                                    },
                                ]}
                            />
                            )}
                            {isKTV && (
                            <HorizontalFieldsRow
                                fields={[
                                    {
                                        label: 'Thời gian đào tạo KTV',
                                        name: 'thoiGianKTV',
                                        component: (
                                            <InputGroup>
                                                <Form.Control
                                                    type="number"
                                                    name="thoiGianKTV"
                                                    value={values.thoiGianKTV}
                                                    onChange={handleChange}
                                                />
                                                <InputGroup.Text>tháng</InputGroup.Text>
                                            </InputGroup>
                                        ),
                                        error: errors.thoiGianKTV,
                                    },
                                    {
                                        label: 'Học phí KTV',
                                        name: 'hocPhiKTV',
                                        component: (
                                            <>
                                                <Form.Control type="number" name="hocPhiKTV" value={values.hocPhiKTV} onChange={handleChange} />
                                                {errors.hocPhiKTV && <div className="text-danger small mt-1">{errors.hocPhiKTV}</div>}
                                            </>
                                        )
                                    },
                                ]}
                            />
                            )}

                            <DoiTuongMienGiamFields values={values} errors={errors} setFieldValue={setFieldValue} />
                            <Form.Group as={Row} className="mt-4 mb-3">
                                <Col md={{ span: 10, offset: 2 }}>
                                    <ButtonGroup className="mb-2">
                                        <Button type="submit" theme="primary" disabled={isLoading}>
                                            Thêm
                                        </Button>
                                        &nbsp;&nbsp;&nbsp;
                                        <Button onClick={() => history.push(URI_INTERNAL.LOPDAOTAOTHUCHANH_PATH)} theme="secondary">
                                            Hủy
                                        </Button>
                                    </ButtonGroup>
                                </Col>
                            </Form.Group>
                        </Form>
                        );
                    }}
                </Formik>
                {isLoading && <div>Đang lưu...</div>}
            </Card.Body>
        </Card>
    );
};

export default LopDaoTaoThucHanhAdd;
